import { formatDate, formatNumber, isEmpty } from "../../utils/CommonFunctions"

export const formatFieldValue = (value: any, fieldType: string, ignoreZero: boolean = false): string => {
  if (value === undefined || value === null) return ''

  switch (fieldType) {
    case 'currency':
      return new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: 'MVR' 
      }).format(value)
    
    case 'percentage':
      return new Intl.NumberFormat('en-US', { 
        style: 'percent', 
        minimumFractionDigits: 1 
      }).format(value)
    case 'number':
      let val = formatNumber(value, 2, 2, ignoreZero)
      return isEmpty(val) ? (ignoreZero ? '' : '0.00') : val
    case 'date':
      return formatDate(new Date(value))
    case 'image':
      return `<AsyncImage src="${value}" alt="${value}" />`
    case 'tag': 
      let res = '<div class="flex flex-wrap gap-2">'
      value.split(',').forEach((el: string) => {
        res += '<span key="' + el + '" class="px-3 py-1 text-sm rounded-full bg-blue-100 text-blue-600 dark:bg-blue-900 dark:text-blue-300 flex items-center">' + el + '</span>'
      });
      res += '</div>'
      return res
    case 'checkbox':
      return `<div class="flex justify-center">
              <input
                type="checkbox"
                :checked="checked"
                class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
            </div>`;
    case 'status':
      const isActive = value === 'active' || value === '1' || value === 1 || value === true || value === 'True' || value === 'true'
      return isActive ? `<div class="flex items-center space-x-2">
    <div class="w-6 h-6 flex items-center justify-center rounded-full bg-green-500 text-white">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 01.083 1.32l-.083.094-8 8a1 1 0 01-1.32.083l-.094-.083-4-4a1 1 0 011.32-1.497l.094.083L8 12.584l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
      </svg>
    </div>
  </div>` : `<div class="w-6 h-6 rounded-full bg-yellow-500 flex items-center justify-center">
  <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
    <path fill-rule="evenodd" d="M9 12h2v2H9v-2zm0-8h2v6H9V4zm1 14a8 8 0 100-16 8 8 0 000 16z" clip-rule="evenodd"/>
  </svg>
</div>`
      return `<span class="px-2 py-1 text-xs font-medium rounded-full ${
        isActive 
          ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
          : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
      }">${value}</span>`
    
    default:
      return String(value)
  }
}